import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralEarnedCreditIA = function BrandReferralEarnedCreditIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_EARNED_CREDIT_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_EARNED_CREDIT_TITLE = function BRAND_REFERRALS_EARNED_CREDIT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "eFoMBv",
    defaultMessage: [{
      "type": 0,
      "value": "How to earn credit from brand referrals"
    }]
  });
};
var BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION = function BRAND_REFERRALS_EARNED_CREDIT_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "b9gLY6",
    defaultMessage: [{
      "type": 0,
      "value": "To earn credit, the brand must either use your referral link or select you as their referrer when they sign up on Faire. The credit amount depends on the active promotion when you submit the referral. Check your \"Earned credit\" for a specific brand by going to \"Refer brands\" in \"Account\" and selecting the \"Joined\" tab. If you see the messages \"Did not use your link\" or \"Already active\", you’re not eligible for referral credit."
    }]
  });
};